import { render, staticRenderFns } from "./SaleBatchFeatureCTable.vue?vue&type=template&id=74b53387&"
import script from "./SaleBatchFeatureCTable.vue?vue&type=script&lang=js&"
export * from "./SaleBatchFeatureCTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports